import { gql } from '@apollo/client';

export const PROMOTION_RATE = gql`
  query promotionRate($input: FilterArgs) {
    promotionRate(input: $input) {
      term
      mean
      year
    }
  }
`;
